$(document).ready(function () {
    $('.lang-selects select[name="lang"]').on('change', function(){
        let params = 'mainlang=' + $(this).val() + "&type=lang&url=" + window.location.pathname;
        $.post(strAjaxPath + 'update-lang.php', params, function (data) {
            window.location.href = data;
        });
    });

    $('.lang-selects select[name="bdlang"]').on('change', function(){
        let params = "bdlang=" + $(this).val() + "&type=bdlang&url=" + window.location.pathname;
        $.post(strAjaxPath + 'update-lang.php', params, function (data) {
            window.location.href = data;
        });
    });
});